import { AxiosInstance } from "axios";
import { Post } from "../../types/Post";
import { economusBaseURL } from "../xhr";

export class Feed {
  httpClient: AxiosInstance;
  constructor(xhr: AxiosInstance) {
    this.httpClient = xhr;
  }

  async getPosts(): Promise<Post[]> {
    try {
      const axiosResponse = await this.httpClient.get(
        `${economusBaseURL}/feed`,
      );
      if (axiosResponse.data.error) {
        console.error(
          "Posts Fetch Successful But With Error",
          axiosResponse.data.error,
        );
      }

      return axiosResponse.data.posts;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  slicePosts(posts: Post[], numOfPosts: number): Post[] {
    return posts.slice(0, numOfPosts);
  }
}
